export enum Language {
  en = 'en',
  ru = 'ru',
}

export const defaultLanguageKey = Language.en;

export enum UserRole {
  user = 'user',
  trainer = 'trainer',
  moderator = 'moderator',
  admin = 'admin',
  superAdmin = 'superAdmin',
}

export enum AccessScope {
  private = 'private',
  public = 'public',
}

export enum PostsInteractionScope {
  all = 'all',
  subscribers = 'subscribers',
  nobody = 'nobody',
}

export enum AclAccess {
  ALLOW = 'allow',
  DENY = 'deny',
}

export enum ExerciseScope {
  private = 'private',
  publicRequest = 'publicRequest',
  publicReject = 'publicReject',
  public = 'public',
}

export enum ExerciseOptionType {
  integer = 'integer',
  fractional = 'fractional',
  time = 'time',
}

export enum ProgramScope {
  private = 'private',
  protected = 'protected',
}

export enum FormMode {
  edit = 'edit',
  view = 'view',
}

export enum TrainingSetItemStatus {
  notStarted = 'notStarted',
  started = 'started',
  doLate = 'doLate',
  skipped = 'skipped',
  finished = 'finished',
}

export enum RelationStatus {
  requested = 'requested',
  rejected = 'rejected',
  approved = 'approved',
}

export const Header = {
  authorization: `authorization`,
};

export enum CommunityScope {
  private = 'private',
  public = 'public',
}

export enum FileVisibility {
  public = 'public',
  private = 'private',
}

export enum AuthProvider {
  password = 'password',
  google = 'google.com',
  facebook = 'facebook.com',
}

export enum SubscriptionType {
  free = 'free',
  starter = 'starter',
  pro = 'pro',
  trainer = 'trainer',
}

export enum SubscriptionPeriod {
  annual = 'annual',
  monthly = 'monthly',
}

export enum SubscriptionScope {
  starter = 'starter',
  pro = 'pro',
  trainer = 'trainer',
}

export enum RestrictionScope {
  exercise = 'exercise',
  program = 'program',
  programItem = 'programItem',
  training = 'training',
  trainingGeneration = 'trainingGeneration',
  periodStatistics = 'periodStatistics',
}

export enum TrainingStatus {
  notStarted = 'notStarted',
  started = 'started',
  finished = 'finished',
}

export enum ExercisePropertyType {
  muscle = 'muscle',
  muscleGroup = 'muscleGroup',
  equipment = 'equipment',
  category = 'category',
  developedSkill = 'developedSkill',
}

export const PasswordRegex =
  // eslint-disable-next-line
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-\\\/,.?":{}|<>]).+$/;
export const FirebaseErrorCodes = [
  'auth/invalid-credential',
  'auth/email-already-in-use',
  'auth/too-many-requests',
  'auth/popup-closed-by-user',
];

export enum BugReportStatus {
  requested = 'requested',
  responded = 'responded',
  resolved = 'resolved',
  closed = 'closed',
}

export enum AppVariableType {
  string = 'string',
  number = 'number',
  boolean = 'boolean',
  json = 'json',
}
